import { debouncer, documentReady, slideUp, slideDown, getNextSibling, getPrevSibling } from "../Utility/utils";


documentReady((event) => {
  // Custom Select Fields
  custom_select();

  function custom_select(){
    // Open with trigger
    const selectTriggers = document.querySelectorAll('.custom_select__trigger');
    selectTriggers.forEach(elem => {
      elem.addEventListener('click', function(e){
        e.preventDefault();
        elem.blur();

        const options = getNextSibling(elem, '.custom_select__options');

        if(elem.classList.contains('active')){
          elem.classList.remove('active');
          options.classList.remove('active');
          options.setAttribute('aria-hidden', 'false');
        }
        else {
          elem.classList.add('active');
          options.classList.add('active');
          options.setAttribute('aria-hidden', 'true');
        }
      });
    });

    
    // Set select on custom option selection
    const customSelectOptions = document.querySelectorAll('.custom_select li a');
    customSelectOptions.forEach(elem => {
      elem.addEventListener('click', function(e){
        e.preventDefault();
        elem.blur();

        const parent = elem.closest('.custom_select');
        const active = parent.querySelector('.custom_select__option.active');
        const trigger = parent.querySelector('.custom_select__trigger');
        let target;

        if(!!active){
          active.classList.remove('active');
        }

        if(!!elem.closest('.gform_wrapper')){
          const select = getPrevSibling(parent, '.ginput_container_select');
          target = select.querySelector('select');
        }
        else {
          target = getNextSibling(parent, 'select');
        }

        const value = elem.getAttribute('data-value');
        const text = elem.innerHTML;

        target.value = value;
        trigger.querySelector('span').innerHTML = text;

        if(trigger.classList.contains('active')){
          trigger.classList.remove('active');
        }
        else {
          trigger.classList.add('active');
        }

        parent.querySelector('.custom_select__options').classList.remove('active');
        parent.querySelector('.custom_select__options').setAttribute('aria-hidden', 'true');

        elem.classList.add('active');
      });
    });
  }

  const forms = document.querySelectorAll('.gform_wrapper');
  forms.forEach(form => {
    forms_markup(form);

    // Gravity forms ajax callback only works with jQuery. When a form is submitted and comes back with errors,
    // form markup is changed back to the default, so we'll have to reset classes without a callback.
    const submit = form.querySelector('.gform_button');
    submit.addEventListener('click', function(){
      let i = 0;
      const ajaxCheck = setInterval(function(){
        if(i < 50){
          if(form.classList.contains('gform_validation_error')){
            forms_markup(form);
            custom_select();
            clearInterval(ajaxCheck);
          }
        } else {
          clearInterval(ajaxCheck);
        }
        i++;
      }, 100);
    });
  });

  function forms_markup(form){
    // for select fields, set a class to the parent li
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
      const li = select.closest('.gfield');
      li.classList.add('select_field');
    });

    // Check inputs for content, and if content present, move the label up.
    const fields = form.querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]):not(.gform_hidden):not(.datepicker), textarea');
    fields.forEach(field => {
      // ensure the field doesn't have a placeholder
      const placeholder = field.getAttribute('placeholder');

      if(!placeholder){
        const li = field.closest('.gfield');
        if(!!li){
          li.classList.add('set_label_placement');

          // For textarea, add class to li to move the label slightly to the right.
          if(field.classList.contains('textarea')){
            li.classList.add('textarea_wrapper');
          }

          field.addEventListener('focus', function(){
            field_label_placement(field, li);
          });
          field.addEventListener('change', function(){
            field_label_placement(field, li);
          });
          field.addEventListener('blur', function(){
            field_label_placement(field, li);
          });
        }
      }
    });

    // When a field is set to "Medium" size in the gravity form editor, no class is added to the li wrapper to allow for parent css changes.
    // We'll add a class to the li here
    const medium_fields = form.querySelectorAll('.medium');
    medium_fields.forEach(field => {
      const li = field.closest('.gfield');
      li.classList.add('medium');
    });
  }

  function field_label_placement(field, li){
    const fieldContent = field.value;

    if(field === document.activeElement || fieldContent.length){
      li.classList.add('label_up');
    }
    else {
      li.classList.remove('label_up');
    }
  }

  // let formHeading = document.querySelector('#heading_block_61420766582f8');
  // if( formHeading ) {
  //   window.addEventListener("gform_confirmation_loaded", () => {
  //     console.log('test!');
  //     formHeading.innerText('Thank you for your message!');
  //   });
  // }

});
